<template>
    <div id="app">
        <div class="header">
            <div>
                <div class="logo_img" @click="logoClick">
                    <div style="display: flex; align-items: center; float: left; height: 65px">
                        <div class="header-logo">
                            <img id="header-img" src="https://oss.xuetongbao.cn/public/logo-baina.png" />
                        </div>
                    </div>
<!--                    <div style="display: flex; float: left; height: 65px">-->
<!--                        <div class="header-important">-->
<!--                            <div class="company_name">百纳未来（北京）科技发展有限公司</div>-->
<!--                            <div class="header-title company_name">bainabtb.com</div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <div v-if="seen" style="float: right; display: flex; align-items: center; height: 100%">
                    <span style="margin-right: 10px">客服热线： 400-001-3021</span>
                    <span style="margin-right: 10px">|</span>
                    <span class="login-btn" @click="toLoginStore">门店登录</span>
                    <span style="margin: 0 10px">|</span>
                    <span class="login-btn" @click="toLoginGroup">集团登录</span>
                </div>
            </div>
        </div>
        <div class="container" style="clear: both">
            <router-view></router-view>
        </div>

        <div style="width: 90%; margin: 20px auto">
            <div style="height: 1px; padding: 0; background-color: #999"></div>
        </div>
        <div style="width: 90%; margin: 20px auto">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12">
                    <p class="footer_font">电话：400-001-3021</p>
                    <div style="margin: auto" class="footer_font">
                        <a style="color: black" href="https://dxzhgl.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?type=xuke&num=%25E4%25BA%25ACB2-20223797" target="_blank"
                            >增值电信业务经营许可证&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;京B2-20223797</a
                        >
                    </div>
                    <div style="margin: auto" class="footer_font">
                        <a style="color: black" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备16019329号-8</a>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a style="color: black" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502050559" target="_blank">京公网安备 11010502050559号</a>
                    </div>
                    <div style="margin: auto" class="footer_font">©bainabtb.com 百纳未来（北京）科技发展有限公司版权所有</div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <div class="weixin">
                        <img :src="company.qrcode" style="width: 93px; height: 93px; border: 0" />
                    </div>
                    <div class="footer_font">关注百纳通宝商家服务中心公众号</div>
                </el-col>
            </el-row>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px; width: 35px" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Layout',
    data() {
        return {
            activeIndex: '1',
            company: {
                qrcode: require('../../static/other/qrcode2.jpg'),
            },
            scroll: '',
            timer: '',
            seen: true,
            currentMenu: '首页',
        }
    },
    methods: {
        handleSelect(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: 'Index' })
                    break
                case '2-1':
                    window.location.hash = '#产品微观'
                    break
                case '2-2':
                    this.$router.push({ name: 'Fruit' })
                    break
                case '2-3':
                    this.$router.push({ name: 'Fashion' })
                    break
                case '3':
                    this.$router.push({ name: 'Index' })
                    window.location.hash = '#产品特点'
                    break
                case '4':
                    this.$router.push({ name: 'Index' })
                    window.location.hash = '#合作伙伴'
                    break
                case '5':
                    this.$router.push({ name: 'Index' })
                    window.location.hash = '#关于我们'
                    break
            }
        },
        handleSelectMobile(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: 'Index' })
                    this.currentMenu = '首页'
                    break
                case '2-1':
                    this.$router.push({ name: 'Index' })
                    window.location.hash = '#产品微观'
                    this.currentMenu = '首页'
                    break
                case '2-2':
                    this.$router.push({ name: 'Fruit' })
                    this.currentMenu = '生鲜果蔬'
                    break
                case '2-3':
                    this.$router.push({ name: 'Fashion' })
                    break
                case '3':
                    this.$router.push({ name: 'Index' })
                    window.location.hash = '#产品特点'
                    this.currentMenu = '首页'
                    break
                case '4':
                    this.$router.push({ name: 'Index' })
                    window.location.hash = '#合作伙伴'
                    this.currentMenu = '首页'
                    break
                case '5':
                    this.$router.push({ name: 'Index' })
                    window.location.hash = '#关于我们'
                    this.currentMenu = '首页'
                    break
            }
        },
        handleScroll() {
            this.scroll = document.documentElement.scrollTop + document.body.scrollTop //获取滚动后的高度
            if (this.scroll > 600) {
                //判断滚动后高度超过400px,就显示
                this.$refs.btn.style.display = 'block'
            } else {
                this.$refs.btn.style.display = 'none'
            }
        },
        backTop() {
            //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
            this.timer = setInterval(() => {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop
                let ispeed = Math.floor(-osTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
                if (osTop === 0) {
                    clearInterval(this.timer)
                }
            }, 30)
        },
        toLoginStore() {
            window.open('http://erp.bainabtb.com/#/login')
        },
        toLoginGroup() {
            window.open('http://group.bainabtb.com/#/login')
        },
        register() {
            window.open('https://admin.bainabtb-tech.com/registe')
        },
        menuSeen() {
            // 屏幕尺寸
            let screenHeight = document.body.clientWidth
            if (screenHeight > 415) {
                this.seen = true
            } else {
                this.seen = false
            }
        },
        logoClick() {
            // 跳转页面
            window.location.href = 'http://www.bannerway.cn/'
            this.$router.push({ name: 'Index' })
            this.currentMenu = '首页'
        },
    },
    mounted() {
        this.menuSeen()
        window.addEventListener('scroll', this.handleScroll)
    },
}
</script>
<style>
/* 谷歌浏览器滚动条隐藏 */
::-webkit-scrollbar {
    display: none;
}

/* 火狐浏览器滚动条隐藏 */
* {
    scrollbar-width: none;
}

/* ie浏览器滚动条隐藏 */
* {
    -ms-overflow-style: none;
}
</style>

<style scoped>
.login-btn {
    cursor: pointer;
}
.login-btn:hover {
    color: #409eff;
}
#app {
    /* display: none; */
    overflow-y: hidden;
}

.logo_img {
    float: left;
    width: 30%;
    cursor: pointer;
}

#back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer;
}

.bei {
}

.header-title {
    font-size: 1em;
}

.company_name {
    font-weight: normal;
    font-size: 1em;
}

.footer_font {
    font-size: 1em;
}

#menu_index {
    float: left;
    width: 50%;
    height: 100%;
}

.header {
    width: 100%;
    height: 65px;
    position: fixed;
    background: #ffff;
    z-index: 999;
    left: 0;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid #ebeef5;
}
.header>div{
  width: 90%;
  height: 65px;
  margin:0 auto;
}
.container{
  margin-top: 65px;
}
@media screen and (max-device-width: 415px) {
    .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer;
    }

    .footer_font {
        font-size: 0.875em;
    }

    #menu_index {
        float: right;
        width: auto;
        height: 100%;
    }

    .mobile_menu {
    }
}

#header-img {
    width: 170px;
    height: 40px;
    float: left;
    margin: auto;
}

.header-logo {
    height: 40px;
    width: 175px;
    align-self: center;
}

.header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
}

.weixin {
    margin-left: 80px;
}

.footer {
    display: flex;
    align-items: center;
    margin: 10px auto;
    width: 90%;
}

a {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}
</style>
